import { Copy, CopyCheck } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

import { logError } from '../../../utils';

type CopyToClipboardButtonProps = {
    textToCopy: string;
    size?: number;
};

export const CopyToClipboardButton = ({
    textToCopy,
    size = 16,
}: CopyToClipboardButtonProps) => {
    const [isCopied, setIsCopied] = useState(false);

    const handleCopyClick = async () => {
        try {
            await navigator.clipboard.writeText(textToCopy);
            setIsCopied(true);
            toast.success('Copied to clipboard!');
            setTimeout(() => setIsCopied(false), 2000); // Reset "Copied!" message after 2 seconds
        } catch (err) {
            logError('CopyToClipboardButton', err);
            toast.error('Failed to copy to clipboard.');
            // Optionally, provide user feedback about the error
        }
    };

    return (
        <button
            aria-label="Copy to clipboard"
            className="cursor-pointer"
            onClick={handleCopyClick}
            type="button"
        >
            {isCopied ? <CopyCheck size={size} /> : <Copy size={size} />}
        </button>
    );
};
